import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../utils/Customer/apiBaseQuery";
import {
    AdminLoginRequest,
    GetUiOrderRequest,
    IUIConfigRequest,
} from "../../../types/Request/AdminRequest";
import {
    AdminLoginResponse,
    UiUpdateResponse,
} from "../../../types/Response/AdminResponse";
import { ADMIN_GET_UI_ORDER, ADMIN_LOGIN, ADMIN_LOGOUT, ADMIN_REARRANGE_UI } from "../../../config/apiUrlsAdmin";

export const adminAuthAPi = createApi({
    reducerPath: "adminAuthAPi",
    baseQuery: axiosBaseQuery(),

    endpoints: (builder) => ({
        adminLogin: builder.mutation<AdminLoginResponse, AdminLoginRequest>({
            query: (data) => ({
                url: `${ADMIN_LOGIN}`,
                method: "post",
                data: data,
            }),
        }),
        CreateOrUpdateUI: builder.mutation<UiUpdateResponse, IUIConfigRequest>({
            query: (data) => ({
                url: `${ADMIN_REARRANGE_UI}`,
                method: "post",
                data: data,
            }),
        }),
        GetUiOrder: builder.query<any, {screenName:string,clientType:number}>({
            query: ({ screenName, clientType }) => ({
                url: `${ADMIN_GET_UI_ORDER}?screenName=${screenName}&clientType=${clientType}`,
                method: "get",
            }),
        }),
        adminLogout:builder.mutation<boolean,void>({
            query:()=>({
                url:`${ADMIN_LOGOUT}`,
                method:"post"
            })

        }),
    })
});

export const { useAdminLoginMutation, useCreateOrUpdateUIMutation, useLazyGetUiOrderQuery,useAdminLogoutMutation } =
    adminAuthAPi;

